import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { Suspense } from "react"
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"
import "./App.css"
import Layout from "./components/layout/Layout"
import { Loader } from "./components/state/Loader"
import Connexion from "./views/authent/Connexion"
import PrivateRoute from "./views/authent/PrivateRoute"
import ResetPassword from "./views/authent/ResetPassword"
import ResetPasswordRequest from "./views/authent/ResetPasswordRequest"
import Signup from "./views/authent/Signup"
import Home from "./views/home/Home"
import Welcome from "./views/Welcome"

const queryClient = new QueryClient()

const App = () => {
  return (
    <Suspense fallback={<Loader />}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <Routes>
            <Route element={<Layout />}>
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Home />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route path="/login" element={<Connexion />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/welcome">
              <Route index element={<Welcome />} />
              <Route path=":id" element={<Welcome />} />
            </Route>
            <Route
              path="/reset-password-request"
              element={<ResetPasswordRequest />}
            />
            <Route path="/reset" element={<ResetPassword />} />
          </Routes>
        </Router>
      </QueryClientProvider>
    </Suspense>
  )
}

export default App
